import { render, staticRenderFns } from "./WorkExpandableY.vue?vue&type=template&id=285b6094"
import script from "./WorkExpandableY.vue?vue&type=script&lang=js"
export * from "./WorkExpandableY.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports